import { render, staticRenderFns } from "./notification-campaign-list.vue?vue&type=template&id=0651e1f0&scoped=true"
import script from "./notification-campaign-list.vue?vue&type=script&lang=js"
export * from "./notification-campaign-list.vue?vue&type=script&lang=js"
import style0 from "./notification-campaign-list.vue?vue&type=style&index=0&id=0651e1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0651e1f0",
  null
  
)

export default component.exports